module.exports = __webpack_public_path__ + "static/media/topImage0614.7c24cc1e.png";